export enum REVIEWS_PERMISSIONS {
  REVIEWS_VIEW = 'REVIEW'
}
